import ReactDOM from "react-dom/client";
import App from "./App";
import "typeface-roboto";
import "./index.css";
import "./config.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
